import { SchemaTypesEnum } from '@spazious/dollhouse-fsetup';

import { formatSchemaType } from './formatSchemaType.js';

const schemaTypeOverrides: Record<string, string> = {
  FEnsembleClassroom: 'FEnsembleDesktop',
  FArrangementShapeU: 'FArrangementUshape',
};

export const parseFCompositionSchemaId = (schemaType: string, payload: number = 0) => {
  const formattedSchemaType = formatSchemaType(schemaType);
  const schemaTypeId =
    SchemaTypesEnum[
      (schemaTypeOverrides[formattedSchemaType] ?? '') as keyof typeof SchemaTypesEnum
    ] ?? SchemaTypesEnum[formattedSchemaType as keyof typeof SchemaTypesEnum];

  return schemaTypeId | (payload << 8);
};
